export const configKeys = {
  /**
   * Config key for settings api uri.
   */
  SETTINGS_URI_CONFIG_KEY: 'apis.settings.uri',

  /**
   * Config key for session auth token.
   */
  SESSION_AUTH_TOKEN: 'session.authToken',

  /**
   * Config key for session tenant id.
   */
  SESSION_TENANT_ID: 'session.tenantId'
};

